import { type AppDispatch } from "features/Application/globaltypes/redux";
import { gotContent, reqContent, errContent, setIsContentLoaded } from "../slices/landingPageSlice";
import DataService from "features/Application/services/dataServices/typedDataService";
import azureStorageUtils from "utils/azureStorageUtils";

export const getLandingPageContent = (id: number) => async (dispatch: AppDispatch) => {
  dispatch(reqContent());
  try {
    const contentUrlWithSas: string =
      await DataService.threatDefence.campaigns.getLandingPageContentUrlWithSasAsync(id);
    const html = await azureStorageUtils.downloadAsString(contentUrlWithSas);
    dispatch(gotContent({ contentUrlWithSas, html }));
    dispatch(setIsContentLoaded(true));
  } catch (error: any) {
    dispatch(errContent(error));
  }
};
